import { registerBottomSheets, BottomSheetComponent } from '@bonanza-social/navigation';

import { Notification } from '../bottomSheets';

const bottomSheets = {
  Notification,
};

registerBottomSheets('notifications', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    notifications: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
